// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".file-wrapper[data-v-5eda9dcc] {\n  width: 100%;\n  height: 350px;\n  line-height: 350px;\n  text-align: center;\n  background: #e6ecf4;\n}\n.file-wrapper .text[data-v-5eda9dcc] {\n  position: absolute;\n  top: 50px;\n  left: 50%;\n  transform: translateX(-50%);\n}", ""]);
// Exports
module.exports = exports;
